var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * 创建人：D
 * 时间：2019-03-8
 * 描述：弹出框服务
 * 更新记录:
 */
import { Injectable } from '@angular/core';
import { SwMessageService } from '../components/basic-components/sw-message/sw-message.service';
/**
 * 提示框公共服务
 */
var SwMassageBoxService = /** @class */ (function () {
    /**
     * @ignore
     */
    function SwMassageBoxService(swMessageService) {
        this.swMessageService = swMessageService;
    }
    /**
    * 错误提示卡片（自动销毁）
    * @param title 提示类型
    */
    SwMassageBoxService.prototype.waringError = function (title) {
        this.swMessageService.showAlert(title, 'we');
    };
    /**
     * 错误提示卡片（自动销毁）
     * @param title 提示类型
     */
    SwMassageBoxService.prototype.waring = function (title) {
        this.swMessageService.showAlert(title, 'e');
    };
    /**
    * 成功提示框
    * @param title 提示类型
    */
    SwMassageBoxService.prototype.success = function (title) {
        this.swMessageService.showAlert(title, 's');
    };
    /**
     * 消息提示框
     * @param title 提示类型
     */
    SwMassageBoxService.prototype.info = function (title) {
        this.swMessageService.showAlert(title, 'i');
    };
    /**
     * 警告提示框
     * @param title 提示类型
     */
    SwMassageBoxService.prototype.danger = function (title) {
        this.swMessageService.showAlert(title, 'w');
    };
    /**
     * 错误提示框,有确认按钮
     * @param title 提示类型
     */
    SwMassageBoxService.prototype.waringAlert = function (title, calback) {
        this.swMessageService.showModal(title, 'e', calback);
    };
    /**
     * 成功提示框,有确认按钮
     * @param title 提示类型
     */
    SwMassageBoxService.prototype.successAlert = function (title, calback) {
        this.swMessageService.showModal(title, 's', calback);
    };
    /**
     * 消息提示框,有确认按钮
     * @param title 提示类型
     */
    SwMassageBoxService.prototype.infoAlert = function (title, calback) {
        this.swMessageService.showModal(title, 'i', calback);
    };
    //警告提示框,有确认按钮
    SwMassageBoxService.prototype.dangerAlert = function (title, calback) {
        this.swMessageService.showModal(title, 'w', calback);
    };
    SwMassageBoxService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [SwMessageService])
    ], SwMassageBoxService);
    return SwMassageBoxService;
}());
export { SwMassageBoxService };
//# sourceMappingURL=sw-massage-box.service.js.map